import { ChangeDetectionStrategy, Component, inject, Input } from "@angular/core";
import { Fee, Fiat, PaymentOption } from "@models";
import { TranslationService } from "@core-services/translation.service";
import { DarkModeService } from "@core-services/dark-mode.service";

@Component({
	selector: "provider-tile",
	templateUrl: "./provider-tile.component.html",
	styleUrls: ["./provider-tile.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class ProviderTileComponent {
	@Input()
	public provider: PaymentOption = null;

	@Input()
	public active: boolean = false;

	@Input()
	public disabled: boolean = false;

	@Input()
	public fiat?: Fiat = null;

	@Input()
	public fiats: Fiat[] = [];

	@Input()
	public showOnlyPercentFees: boolean = false;

	public get fee(): Fee {
		return this.provider.getFeeByFiatId(this.fiat.getId());
	}

	public darkModeService = inject(DarkModeService);

	public constructor(private translationService: TranslationService) {}

	public get fiatsAvailable(): string {
		const fees = this.provider.getFees();
		const availableFiats: string[] = this.fiats
			.filter((fiat: Fiat) => fees.some((fee: Fee) => fee.getFiatId() === fiat.getId()))
			.map((fiat: Fiat) => fiat.getSymbol());

		const and: string = this.translationService.translate("and");
		if (availableFiats.length === 1) {
			return availableFiats[0];
		}
		return (
			availableFiats.splice(0, availableFiats.length - 1).join(", ") +
			" " +
			and +
			" " +
			availableFiats[availableFiats.length - 1]
		);
	}
}
